// This is the copy of the consts from the backend

export enum ObligationType {
  ChamberOfCommerceFee = 'chamber_of_commerce_fee',
  VatReturnDeclaration = 'vat_return_declaration',
  AnnualVatReturnDeclaration = 'annual_vat_return_declaration',
  AnnualAccounts = 'annual_accounts',
  Model500 = 'model_500',
  CorporateIncomeTax = 'corporate_income_tax',
  CommunalBusinessTax = 'communal_business_tax',
  WealthTax = 'wealth_tax',
}

export enum ObligationStatus {
  NotStarted = 'not_started',
  WaitingForClientApproval = 'waiting_for_client_approval',
  Approved = 'approved',
  FillingToAuthority = 'filling_to_authority',
  WaitingForPayment = 'waiting_for_payment',
  Paid = 'paid',
  Done = 'done',
  Submitted = 'submitted',
  WaitingForSubmission = 'waiting_for_submission',
}

const vatStatuses = [
  ObligationStatus.NotStarted,
  ObligationStatus.WaitingForClientApproval,
  ObligationStatus.Approved,
  ObligationStatus.FillingToAuthority,
  ObligationStatus.WaitingForPayment,
  ObligationStatus.Paid,
  ObligationStatus.Done,
];

const annualModel500TaxStatuses = [
  ObligationStatus.FillingToAuthority,
  ObligationStatus.WaitingForPayment,
  ObligationStatus.Paid,
  ObligationStatus.Done,
];

export const obligationStatusMap = {
  [ObligationType.ChamberOfCommerceFee]: [
    ObligationStatus.WaitingForSubmission,
    ObligationStatus.Submitted,
    ObligationStatus.WaitingForPayment,
    ObligationStatus.Paid,
    ObligationStatus.Done,
  ],
  [ObligationType.VatReturnDeclaration]: vatStatuses,
  [ObligationType.AnnualVatReturnDeclaration]: vatStatuses,
  [ObligationType.AnnualAccounts]: [
    ObligationStatus.NotStarted,
    ObligationStatus.WaitingForClientApproval,
    ObligationStatus.Approved,
    ObligationStatus.FillingToAuthority,
    ObligationStatus.Done,
  ],
  [ObligationType.Model500]: [
    ObligationStatus.NotStarted,
    ObligationStatus.WaitingForClientApproval,
    ObligationStatus.Approved,
    ObligationStatus.Done,
  ],
  [ObligationType.CorporateIncomeTax]: annualModel500TaxStatuses,
  [ObligationType.CommunalBusinessTax]: annualModel500TaxStatuses,
  [ObligationType.WealthTax]: annualModel500TaxStatuses,
};
